module.exports = __webpack_public_path__ + "static/mevia-hero-min-6d11e2a076abff6b5b0f14f2c0c4254a.jpg";